module.exports = {
      id: "corona-updates-icon-usage",
      viewBox: "0 0 25.374 25.18",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#corona-updates-icon",
      toString: function () {
        return this.url;
      }
    }